import { defineAsyncComponent } from 'vue'

const Depot = defineAsyncComponent(() => import('./depot.vue'))
const DepotsSelect = defineAsyncComponent(() => import('./depots-select.vue'))
const DepotsTable = defineAsyncComponent(() => import('./depots-table.vue'))

export { Depot, DepotsSelect, DepotsTable }
